import { Notifications } from "@mui/icons-material";
import Badge from "@mui/material/Badge";
import { makeStyles } from "components/mui-core";
import { FlexContent } from "components/FlexContent/FlexContent";
import { useAppNotifications } from "./AppNotificationProvider";

const useStyles = makeStyles()({
  root: {
    width: "40px",
    height: "40px",
    transitionProperty: "background-color, color",
    transitionDuration: ".2s",
    transitionTimingFunction: "ease-in-out",
    cursor: "pointer",
  },
  notificationsOpened: {},
  notificationsClosed: {},
});

export const AppNotificationsButton = ({ open, onOpen }) => {
  const { classes: styles, cx } = useStyles();
  const { visibleNotifications } = useAppNotifications();

  return (
    <FlexContent
      align="center"
      justify="center"
      onClick={onOpen}
      className={cx(
        styles.root,
        open && styles.notificationsOpened,
        !open && styles.notificationsClosed
      )}>
      <Badge
        badgeContent={visibleNotifications.length}
        color="error">
        <Notifications />
      </Badge>
    </FlexContent>
  );
};
